<script>
  import BlockQuote from "$lib/components/BlockQuote.svelte";
  export let data;
</script>

<div class="embedded-content">
  <BlockQuote {...data.fields} />
</div>
